import '../../templates/_components/form/form.js'
import '../../templates/_components/form/fields/gotafe-custom/form-gotafe-custom.js'
import '../../templates/_components/text-and-media/text-and-media.js'
import '../../templates/_components/media/media.js'
import '../../templates/_components/career-pathway/career-pathway.js'
import '../../templates/_components/image-carousel/image-carousel.js'
import '../../templates/_components/image-masonry/image-masonry.js'
